import { PrizesItem } from '@/app/entities/Raffle'
import { useRaffleMutations } from '@/app/hooks/useRaffleMutations'
import { Button } from '@/view/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '@/view/components/ui/dialog'
import { CircleAlert, Trash2 } from 'lucide-react'
import { useState } from 'react'

interface ManageRafflePrizesProps {
  raffleId: string
  prizes: PrizesItem[]
}

export default function ManageRafflePrizes({
  prizes,
  raffleId,
}: ManageRafflePrizesProps) {
  const { deleteRafflePrize } = useRaffleMutations()
  const isPending = deleteRafflePrize.isPending
  const [selectedPrizeId, setSelectedPrizeId] = useState<string | null>(null)

  const handleDelete = async (prizeIndex: number) => {
    try {
      await deleteRafflePrize.mutateAsync({ raffleId, prizeIndex })
      setSelectedPrizeId(null)
    } catch (error) {
      console.log(error)
    }
  }

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      setSelectedPrizeId(null)
    }
  }

  return (
    <div className="flex flex-col gap-5">
      <h3 className="text-lg font-semibold">Prêmios</h3>
      {prizes.map((prize, index) => (
        <div
          key={prize?._id}
          className="flex w-full items-center justify-between rounded-md border p-5 shadow-sm"
        >
          <div className="flex items-center gap-5">
            <div className="flex h-[40px] w-[40px] items-center justify-center rounded-md bg-primary/10">
              {index + 1}º
            </div>
            <p className="font-semibold">{prize?.name}</p>
          </div>

          <Dialog
            open={selectedPrizeId === prize?._id}
            onOpenChange={handleOpenChange}
          >
            <DialogTrigger asChild>
              <Button
                variant="outline"
                size="lg"
                className="px-4 py-3 font-semibold"
                onClick={() => setSelectedPrizeId(prize?._id)}
              >
                <Trash2 size={20} className="mr-2" strokeWidth={1.3} />
                Excluir prêmio
              </Button>
            </DialogTrigger>
            <DialogContent>
              <div className="flex w-full items-center justify-center">
                <CircleAlert className="text-destructive" size={52} />
              </div>
              <p className="mb-2 text-center text-xl">
                Deseja deletar o prêmio {prize?.name}?
              </p>
              <div className="flex justify-end space-x-4">
                <Button
                  size="lg"
                  onClick={() => handleDelete(index)}
                  disabled={isPending}
                  className="w-full rounded-full bg-transparent text-primary hover:bg-primary/10"
                >
                  Sim, deletar
                </Button>
                <Button
                  size="lg"
                  className="w-full rounded-full bg-primary text-white"
                  onClick={() => setSelectedPrizeId(null)}
                >
                  Não, Cancelar
                </Button>
              </div>
            </DialogContent>
          </Dialog>
        </div>
      ))}
    </div>
  )
}
